import { Loader2 } from "lucide-react";
import { batchLabel, pictureUrl } from "../lib/api";

const PALETTE = ["bg-amber-100 text-amber-800", "bg-teal-100 text-teal-800", "bg-rose-100 text-rose-800", "bg-indigo-100 text-indigo-800", "bg-stone-200 text-stone-800"];

export const MemberAvatar = ({ user, size = "h-11 w-11", text = "text-sm" }) => {
  const name = user?.name || "?";
  const initials = name.replace(/^Dr\.?\s*/i, "").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  const color = PALETTE[name.length % PALETTE.length];
  if (user?.picture) return <img src={pictureUrl(user.picture)} alt={name} className={`${size} rounded-full object-cover ring-2 ring-white shrink-0`} />;
  return (
    <div className={`${size} ${color} ${text} rounded-full flex items-center justify-center font-bold ring-2 ring-white shrink-0`}>
      {initials}
    </div>
  );
};

export const Crest = ({ size = "h-9 w-9" }) => (
  <img src="/brand/logo.png" alt="LVB Hostel crest" className={`${size} rounded-full bg-white object-contain ring-1 ring-stone-200 shrink-0`} />
);

export const BatchTag = ({ user, className = "" }) =>
  user?.batch_start ? (
    <span className={`font-typewriter text-[11px] px-2 py-0.5 rounded-sm bg-amber-50 text-amber-800 border border-amber-200 whitespace-nowrap ${className}`}>
      '{batchLabel(user)}
    </span>
  ) : null;

export const PageHeader = ({ eyebrow, title, description, action }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 fade-up">
    <div className="max-w-2xl">
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-stone-900">{title}</h1>
      {description && <p className="mt-3 text-base md:text-lg text-stone-600">{description}</p>}
    </div>
    {action}
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, testid }) => (
  <div data-testid={testid} className="border border-dashed border-stone-300 rounded-lg p-12 text-center bg-white/60">
    {Icon && <Icon className="mx-auto h-8 w-8 text-amber-600 mb-3" />}
    <p className="font-display text-xl font-bold text-stone-800">{title}</p>
    {text && <p className="text-sm text-stone-500 mt-1">{text}</p>}
  </div>
);

export const Loader = ({ full }) => (
  <div className={`flex items-center justify-center ${full ? "min-h-screen" : "py-20"}`} data-testid="loader">
    <Loader2 className="h-6 w-6 animate-spin text-amber-600" />
  </div>
);
